import React, { useEffect } from 'react';
import { useFilters } from '../FilterContext';
import EMIChip from 'components/Elements/EMIChip/EMIChip';
import { processChipsForAPI } from 'helpers/chipProcessor';

export const ChipsFilter = () => {
	const { config, updateFilter, filterValues } = useFilters();
	const chipsConfig = config.filters?.chips;

	// Get chips from FilterContext (initialization handled by useFilterInitialization in parent component)
	const chips = filterValues.chips?.value || [];

	// ChipsFilter owns the chip-array -> backend report-DTO shape translation.
	// Whenever the chip array changes (from any setter - this component's
	// remove handler, initialization, persistence layer, other chip-adding
	// components), we flatten the typed chips into id-arrays via
	// processChipsForAPI and write that onto the entry's reportParams so
	// FilterContext.buildReportFilterContext picks it up at report-fire time
	// without needing to know "chips" exists.
	useEffect(() => {
		const chipsEntry = filterValues.chips;
		if (!chipsEntry) return;
		const newReportParams = processChipsForAPI(Array.isArray(chipsEntry.value) ? chipsEntry.value : []);
		// Avoid update loop: skip if already in sync.
		if (JSON.stringify(chipsEntry.reportParams) === JSON.stringify(newReportParams)) return;
		updateFilter('chips', chipsEntry.value, chipsEntry.params, false, newReportParams);
	}, [filterValues.chips, updateFilter]);

	if (!chipsConfig?.enabled) {
		return null;
	}
	const hiddenChipTypes = chipsConfig.hiddenTypes || [];

	// Filter chips based on configuration - only show non-hidden chips
	const visibleChips = chips.filter(chip =>
		!hiddenChipTypes.includes(chip.chipType)
	);

	const handleRemoveChip = (chipToRemove) => {
		const updatedChips = chips.filter(chip =>
			!(chip.chipType === chipToRemove.chipType &&
			  chip.id === chipToRemove.id &&
			  chip.value === chipToRemove.value)
		);
		updateFilter('chips', updatedChips, { chips: updatedChips }, false, processChipsForAPI(updatedChips));
	};

	// Always render container with spacing, only show chips if there are visible ones
	return (
		<div style={{ marginTop: 20 }}>
			{visibleChips.length > 0 && (
				<EMIChip
					data={visibleChips}
					deleteHandler={handleRemoveChip}
					hideChips={hiddenChipTypes}
				/>
			)}
		</div>
	);
};